<script setup>
import {computed} from 'vue'
import placeholderImage from '@/assets/placeholder.jpg'

const props = defineProps({
    previousConference: {
        type: Object,
        required: true,
    },
})

/**
 * Input example: previousConference = { our_speakers_section_title: "Our Keynote Speakers" }
 * Output example: "Our Keynote Speakers"
 */
const speakersSectionTitle = computed(() => {
    return props.previousConference.our_speakers_section_title?.trim() || 'Our Speakers'
})
</script>

<template>
    <section v-if="previousConference.speakers?.length" class="space-y-5">
        <div>
            <h2 class="font-heading text-2xl font-semibold text-slate-900">{{ speakersSectionTitle }}</h2>
            <div class="mt-3 h-1 w-16 bg-teal-700"></div>
        </div>

        <div class="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
            <article
                v-for="speaker in previousConference.speakers"
                :key="speaker.id"
                class="rounded-md border border-slate-200 bg-white px-6 py-8 text-center shadow-sm">
                <img
                    class="mx-auto mb-6 h-36 w-36 rounded-full object-cover"
                    :src="speaker.image || placeholderImage"
                    :alt="speaker.name" />

                <h3 class="font-heading text-lg font-medium text-slate-900">
                    {{ speaker.name }}
                </h3>

                <p v-if="speaker.description" class="mt-3 text-sm leading-6 text-slate-600">
                    {{ speaker.description }}
                </p>

                <a
                    v-if="speaker.affiliation_href"
                    :href="speaker.affiliation_href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="mt-4 inline-block text-sm font-medium text-teal-700 hover:text-teal-800">
                    {{ speaker.affiliation }}
                </a>

                <p v-else-if="speaker.affiliation" class="mt-4 text-sm font-medium text-slate-700">
                    {{ speaker.affiliation }}
                </p>
            </article>
        </div>
    </section>
</template>

<style scoped></style>
